import React from 'react'
import styled from 'styled-components'
import { media } from '../../../utils/style'
import IconVan from '../../../vectors/IconVan'

const StyledAdditional = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;
  margin-bottom: 32px;

  ${media.MediumScreenUp`
    justify-content: flex-end;
  `}

  svg {
    vertical-align: middle;
    fill: ${(props) => props.theme.colors.electric_blue};
    margin-right: 4px;
  }

  a {
    color: ${(props) => props.theme.colors.electric_blue};
    font-weight: bold;
  }
`

export const Additional = () => {
  return (
    <StyledAdditional>
      <div>
        <IconVan /> We also sell{' '}
        <a href="/vans">Vans&nbsp;and&nbsp;Camper&nbsp;Vans</a>
      </div>
    </StyledAdditional>
  )
}
